import { render, staticRenderFns } from "./modal-escoger.vue?vue&type=template&id=06a7ef2c&scoped=true"
import script from "./modal-escoger.vue?vue&type=script&lang=js"
export * from "./modal-escoger.vue?vue&type=script&lang=js"
import style0 from "./modal-escoger.vue?vue&type=style&index=0&id=06a7ef2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7ef2c",
  null
  
)

export default component.exports